export default __webpack_public_path__ + "locales/it/Common.json?hash=c5695b9a48a99e8ce6228ef4ade26cf4";